<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5.59 13.43">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          d="M0,.27V13.16c0,.23.18.35.29.2L5.52,6.92a.34.34,0,0,0,0-.41L.29.06C.18-.08,0,0,0,.27"
          :fill="iconColor"
        ></path>
      </g>
    </g>
  </svg>
</template>

<script>
  import { computed } from 'vue'
  import { useTheme } from 'vuetify'

  export default {
    name: 'ArrowLeft',
    setup() {
      const theme = useTheme()
      const iconColor = computed(() =>
        theme.global.current.value.dark ? '#CECECE' : '#383935'
      )

      return {
        iconColor,
      }
    },
  }
</script>

<style scoped>
  svg {
    width: 5.59px;
    height: 13.43px;
    transform: rotate(180deg);
  }
</style>
